module.exports = {
	"authentication": {
		"authenticate": {
			"external": "Log ind med",
			"back": "Gå tilbage",
			"dashboard": "Gå til mit dashboard",
			"user": "Bruger",
			"title": "Log ind",
			"email": "Din email",
			"password": "Dit kodeord",
			"reset": "Nulstil kodeord",
			"forgot": "Glemt kodeord?",
			"forgot_text": "Du kan hurtigt lave et nyt kodeord ved at nulstille det herunder. Vi sender en mail til dig.",
			"non_existing": "Har du ikke en profil?",
			"create": "Opret",
			"errors": {
				"email": "Din email er ikke gyldig",
				"email_empty": "Du skal angive din e-mail",
				"password_empty": "Du skal angive dit kodeord",
				"login_error": "Fejl i enten mail eller kodeord"
			}
		}
	}
};